export default __webpack_public_path__ + "static/media/Aura-Egg__81.9cb08cc6.png";